export const getMobileOperatingSystem = () => {
  if (typeof window !== 'undefined') {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }
    if (/huawei/i.test(userAgent)) {
      return 'https://appgallery.huawei.com/app/C102156391';
    }
    if (/android/i.test(userAgent)) {
      return 'https://play.google.com/store/apps/details?id=az.kapitalbank.mbanking&hl=az&gl=US&pli=1';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'https://apps.apple.com/us/app/birbank/id1293207342';
    }

    return '';
  }
};
